// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent as firebaseLogEvent } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY || process.env.REACT_APP_API_KEY || "demo-key",
  authDomain: import.meta.env.VITE_AUTH_DOMAIN || process.env.REACT_APP_AUTH_DOMAIN || "demo-project.firebaseapp.com",
  projectId: import.meta.env.VITE_PROJECT_ID || process.env.REACT_APP_PROJECT_ID || "demo-project",
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET || process.env.REACT_APP_STORAGE_BUCKET || "demo-project.appspot.com",
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID || process.env.REACT_APP_MESSAGING_SENDER_ID || "123456789",
  appId: import.meta.env.VITE_APP_ID || process.env.REACT_APP_APP_ID || "1:123456789:web:demo",
  measurementId: import.meta.env.VITE_MEASUREMENT_ID || process.env.REACT_APP_MEASUREMENT_ID || undefined,
};

// Check if we have valid configuration
const hasValidConfig = (import.meta.env.VITE_PROJECT_ID || process.env.REACT_APP_PROJECT_ID) && 
                       (import.meta.env.VITE_API_KEY || process.env.REACT_APP_API_KEY) && 
                       !(import.meta.env.VITE_PROJECT_ID || process.env.REACT_APP_PROJECT_ID).includes('demo');

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check (reCAPTCHA v3) when a site key is configured.
// Register the app in Firebase Console -> App Check, then set VITE_RECAPTCHA_SITE_KEY.
// Until then, this is a no-op so existing behavior is unchanged.
const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
if (hasValidConfig && recaptchaSiteKey) {
  if (import.meta.env.DEV) {
    // Dev only - register the printed debug token in Firebase Console -> App Check -> Debug tokens.
    // eslint-disable-next-line no-restricted-globals
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true
    });
  } catch (err) {
    console.warn('App Check initialization failed:', err);
  }
}

// Initialize and export services
// Prefer default Firestore database unless an explicit database ID is provided via env
const firestoreDatabaseId = import.meta.env.VITE_FIRESTORE_DB || process.env.REACT_APP_FIRESTORE_DB;
export const db = hasValidConfig
  ? (firestoreDatabaseId ? getFirestore(app, firestoreDatabaseId) : getFirestore(app))
  : null;
export const auth = hasValidConfig ? getAuth(app) : null;
export const analytics = hasValidConfig ? getAnalytics(app) : null;
export const isFirebaseConfigured = hasValidConfig;

export const logEvent = (eventName, params) => {
  if (analytics) firebaseLogEvent(analytics, eventName, params);
};

// Log configuration status
if (!hasValidConfig) {
  console.warn('Firebase not properly configured. Please set up your .env file with valid Firebase credentials.');
} else if (import.meta.env.DEV || process.env.NODE_ENV === 'development') {
  console.log('Firebase initialized with project:', firebaseConfig.projectId);
  
  // Log auth state changes
  auth.onAuthStateChanged((user) => {
    console.log('Auth state changed:', user ? `User ${user.uid}` : 'No user');
  });
} 